import axios from 'axios';
import addresstypes from './addresstypes';
import contacts from './contacts';
import _ from 'lodash'
import companyTypes from './company-types';

// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list: [],
    company : 0,
    take: 25,
    skip: 0,
    loading: false,
    allLoaded: false,
    addNew: false,
    columns : [
        {
          key: "data.name",
          label: "name",
        },
        {
          key: "data.bank_name",
          label: "bank_name",
        },
      ],
    types: {
        ach : [
                {name : "name"},
                {name : "account_number"},
                {name : "routing_number", parse_function : "parse_max_9"},
                {name : "swift", parse_function : "parse_iban"},
                {name : "bank_name"},
                {name : "bank_address"},
            ],
        int : [
            {name : "name"},
            {name : "account_number"},
            {name : "iban", parse_function : "parse_iban"},
            {name : "swift", parse_function : "parse_upper"},
            {name : "bank_name"},
            {name : "bank_address"},
        ],
    },
    filter: {},
    workingOn: [],
    isSaving: false,
    infinity: {
        active: false,
        clear: false,
        search: "",
        columns: ['data.name', 'data.type'],
        allLoaded: false,
        loading: false,
        loadingMore: false,
        take: 50,
    },
    relationTypes: [],
    pagination: {
        currentPage: 1,
        totalPageCount: 1,
    },
    meat: {},
})

// getters
const getters = {
    getBeneficialAccountById: (state) => (id) => {
        var index = state.list.findIndex(item => item.id == id);
        if(index > -1){
            return state.list[index];
        }
        return {data : {}, company_id : ""};
    },
}

// actions
const actions = {
    async update({ commit, state, rootState }, data) {
        commit("isSaving", true);
        await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/beneficialaccounts/" + data.id, data).then(response => {
            commit("update", response.data.data);
        })
        commit("isSaving", false);
    },
    async store({ commit, state, rootState }, data) {
        commit("isSaving", true);
        await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/beneficialaccounts", data).then(response => {
            commit("store", response.data.data);
        })
        commit("isSaving", false);
    },
    async load({ commit, state, rootState }, page = 1) {
        if (state.infinity.clear == true) {
            commit("infinityClear");
        }
        if (state.allLoaded == false && state.loading == false) {
            commit("isLoading", true);
                if(state.infinity.active == true){
                    commit("skip", state.list.length);
                }else{
                    commit("skip", (page - 1) * state.take);
                }
                var skip = state.skip;
            await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/beneficialaccounts", { params: {company_id : state.company, search: state.infinity.search, take: state.take, skip: state.skip, columns: state.infinity.columns, filter: state.filter } }).then((response) => {
                commit("set", response.data.data);
                commit("pagination", _.get(response, "data.meta.pagination", { total: 0, take: state.take }))
                commit("isLoading", false);
            });
            commit("isLoading", false);
        }
    },
    async destroy({commit, state, rootState}, data) {
      await axios.delete(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/beneficialaccounts/" + data.id).then((response) => {
            commit("removeId", response.data.deleted);
        });
    },
}

// mutations
const mutations = {
    pagination(state, object) {
        state.meta = object;
        if (state.skip <= 0) {
            state.pagination.currentPage = 1;
        } else {
            state.pagination.currentPage = (state.skip / state.take) + 1;
        }
        state.pagination.totalPageCount = Math.ceil(state.meta.total / state.take);

        if(state.infinity.active == true && state.meta.total <= state.skip){
            state.allLoaded = true;
        }
    },
    setCompany(state, id){
        state.company = id;
    },
    clean(state) {
        state.list = [];
        state.skip = 0;
        state.infinity.allLoaded = false;
        state.loaded = false;
        state.allLoaded = false;
        state.workingOn = [];
    },
    skip(state, skip) {
        state.skip = skip;
    },
    isLoading(state, status){
        state.isLoading = status;
        state.loading = status;
    },
    isSaving(state, status){
        state.isSaving = status;
    },
    infinityClear(state){
        state.skip = 0;
        state.infinity.allLoaded = false;
        state.list = [];
    },
    update(state, data) {
        var index = state.list.findIndex(item => item.id == data.id)
        if (index >= 0) {
            state.list[index] = data;
        }
    },
    store(state, data) {
        state.list.unshift(data);
    },
    set(state, data) {
        if (state.infinity.clear == true) {
            state.list = [];
            state.infinity.allLoaded = false;
        }
        if (state.infinity.active) {
            state.list.push(...data);
        } else {
            state.list = data;
        }

        state.infinity.clear = false;
    },
    removeId(state, id) {
        var index = state.list.findIndex(item => item.id == id);
        if (index >= 0) {
            state.list.splice(index, 1);
        }
    },
    activateInfinity(state, status){
        state.infinity.active = status;

    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
}
